<template>
  <SfModalPortal
    modal-id="echarts-graph-modal"
    size="wide"
    @opened="handleOpen"
    @close="handleClose"
  >
    <template #title>{{ title }}</template>

    <template #body>
      <div
        v-if="graphData"
        ref="echartsContainer"
        class="report-graph tw-w-full tw-h-[400px]"
      />
      <div v-if="description" class="report-graph-description-wrapper">
        <div
          class="
            tw-rounded-lg
            tw-border-2
            tw-border-solid
            tw-border-sf-snow-dark
            tw-p-6
          "
        >
          <p v-dompurify-html="description"></p>
        </div>
      </div>
    </template>
  </SfModalPortal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { SfModalPortal } from '@app/shared/vue/components/sf-modal'
import { useEchartsChart } from '@app/shared/echarts/use-echarts-chart'
import type { GraphData } from '../types'

interface EchartsGraphModalPayload {
  title: string
  description: string | null
  graphData: GraphData
}

const title = ref<string | null>(null)
const description = ref<string | null>(null)
const graphData = ref<GraphData | null>(null)
const echartsContainer = ref<HTMLElement | null>(null)

useEchartsChart(echartsContainer, graphData)

function handleOpen(payload: EchartsGraphModalPayload) {
  title.value = payload.title
  description.value = payload.description
  graphData.value = payload.graphData
}

function handleClose() {
  graphData.value = null
}
</script>
